import * as actionsTypes from "./actionTypes";

const searchInterfaces = searchFields => ({
    type: actionsTypes.INTERFACE_SEARCH_REQUEST,
    searchFields
});

const listInterfaces = searchFields => ({
    type: actionsTypes.GET_INTERFACE_LIST_REQUEST,
    searchFields
});

const getEntityLastReadings = entityId => ({
    type: actionsTypes.GET_ENTITY_LAST_READINGS_REQUEST,
    entityId
});

const getInterfaceData = interfaceId => ({
    type: actionsTypes.GET_INTERFACE_REQUEST,
    interfaceId
});

const createInterface = interfaceData => ({
    type: actionsTypes.CREATE_INTERFACE_REQUEST,
    interfaceData
});

const editInterface = (interfaceId, interfaceData) => ({
    type: actionsTypes.EDIT_INTERFACE_REQUEST,
    interfaceId,
    interfaceData
});

const deleteInterface = interfaceId => ({
    type: actionsTypes.DELETE_INTERFACE_REQUEST,
    interfaceId
});

const resetInterfaceForm = () => ({
    type: actionsTypes.RESET_INTERFACE_FORM
});

const getUnitTypeList = () => ({
    type: actionsTypes.GET_UNIT_TYPE_LIST_REQUEST
});

const getCategoryList = () => ({
    type: actionsTypes.GET_CATEGORY_LIST_REQUEST
});

const getAssociatedEntitiesList = interfaceId => ({
    type: actionsTypes.GET_ASSOCIATED_ENTITIES_LIST_REQUEST,
    interfaceId
});

const loadInterfacesDetails = (interfaceIds) => ({
    type: actionsTypes.LOAD_INTERFACES_DETAILS_REQUEST,
    interfaceIds
});

const getEntityListForInterfacesOfTerminal = terminalsParentEntityId => ({
    type: actionsTypes.GET_TERMINALS_RELATED_ENTITIES_REQUEST,
    terminalsParentEntityId
})

export default {
    searchInterfaces,
    listInterfaces,
    getEntityLastReadings,
    getInterfaceData,
    createInterface,
    editInterface,
    deleteInterface,
    resetInterfaceForm,
    getUnitTypeList,
    getCategoryList,
    getAssociatedEntitiesList,
    loadInterfacesDetails,
    getEntityListForInterfacesOfTerminal,
}